if (!customElements.get('countdown-timer')) {
  class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.endDate = new Date(this.dataset.endDate).getTime();
      if (!Number(this.endDate)) return;

      window.initLazyScript(this, this.init.bind(this));
    }

    init() {
      this.daysEl = this.querySelector('.js-days');
      this.hoursEl = this.querySelector('.js-hours');
      this.minsEl = this.querySelector('.js-mins');
      this.secsEl = this.querySelector('.js-secs');
      this.padNumbers = this.dataset.padNumbers === 'true';

      this.second = 1000;
      this.minute = 60 * this.second;
      this.hour = 60 * this.minute;
      this.day = 24 * this.hour;

      this.timer();
      this.interval = setInterval(this.timer.bind(this), this.second);
    }

    timer() {
      const timeDiff = this.endDate - new Date();

      if (timeDiff < 0) {
        clearInterval(this.interval);
        if (this.daysEl && this.hoursEl && this.minsEl && this.secsEl) {
          const z = this.padNumbers ? '00' : '0';
          this.daysEl.textContent = z;
          this.hoursEl.textContent = z;
          this.minsEl.textContent = z;
          this.secsEl.textContent = z;
        }
        return;
      }

      if (!this.daysEl || !this.hoursEl || !this.minsEl || !this.secsEl) {
        clearInterval(this.interval);
        return;
      }

      const days = Math.floor(timeDiff / this.day);
      const hours = Math.floor(timeDiff / this.hour);
      const mins = Math.floor(timeDiff / this.minute);
      const secs = Math.floor(timeDiff / this.second);

      const d = days;
      const h = hours - days * 24;
      const m = mins - hours * 60;
      const s = secs - mins * 60;

      const fmt = (n) => (this.padNumbers ? String(n).padStart(2, '0') : String(n));

      this.daysEl.textContent = fmt(d);
      this.hoursEl.textContent = fmt(h);
      this.minsEl.textContent = fmt(m);
      this.secsEl.textContent = fmt(s);
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
}
